// CustomTooltip.jsx
import React from 'react';
import { Tooltip } from 'react-tooltip';

const CustomTooltipCellRenderer = (props) => {
    const tooltipId = `tooltip-${props.rowIndex}-${props.colDef.field}`;
    return (
        <>
            <div
                data-tooltip-id="ag-grid-tooltip"
                data-tooltip-content={props.value}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '180px',
                    display: 'inline-block',
                }}
            >
                {props.value}
            </div>
            <Tooltip id={tooltipId} place="top" />
        </>
    );
};

export default CustomTooltipCellRenderer;
// CustomGridTooltip.jsx